<template>
    <div class="mx-auto col-lg-6 col-md-8 col-sm-12 header-margin">
        <div class="text-center p-2">
            <h3>{{ $t('aube-coin.account_status_v3.title') }}</h3>
        </div>

        <div class="text-center mb-5">
            <p>{{ $t('home.messages.setting') }}</p>
        </div>

        <div>
            <div class="show_ID">
                <p>{{ $t('aube-coin.account.email') }} :
                    <span>{{email ? email : '-'}}</span>
                </p>
                <p v-show="showForceClubId">{{ $t('aube-coin.account.forceClubId') }} :
                    <span>{{forceClubId ? forceClubId : '-'}}</span>
                </p>
                <p>{{ $t('aube-coin.account.connectorId') }} :
                    <span>{{connectorId ? connectorId : '-'}}</span>
                </p>
                <p>{{ $t('aube-coin.account.questId') }} :
                    <span>{{questId ? questId : '-'}}</span>
                </p>
            </div>

            <!-- KYC -->
            <div v-if="isKycActive">
                <div class="message-card">
                    <h4 v-text="$t('kyc.message.title')"></h4>
                    <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                    <span v-else>{{ $t(`kyc.message.statuses[${kycStatus}]`) }}</span>
                </div>
            </div>
            <div v-else>
                <MessageCard
                    :title="$t('kyc.message.title')"
                    :link="'/kyc-settings'"
                    :active="!isKycActive"
                    :disable="!isLoaded()"
                >
                    {{ isLoaded() ? $t(`kyc.message.statuses[${kycStatus}]`) : $t("loading") }}
                </MessageCard>
            </div>
            <!-- Aube Coin -->
            <div v-if="isAubeCoinStakingApplied">
                <div class="message-card">
                    <h4 v-text="$t('aube-coin.staking.title')"></h4>
                    <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                    <span v-else>{{ $t(`aube-coin.staking.statuses[${aubeCoinStackingStatus}]`) }}</span>
                </div>
            </div>
            <div v-else>
                <MessageCard
                    :title="$t('aube-coin.staking.title')"
                    :link="'/aube-coin-staking-application'"
                    :active="!isAubeCoinStakingApplied"
                    :disable="!isLoaded() || !isKycActive"
                >
                    {{ isLoaded() ? $t(`aube-coin.staking.statuses[${aubeCoinStackingStatus}]`) : $t("loading") }}
                </MessageCard>
            </div>
            <!-- Membership Fee -->
            <div v-if="isMembershipFeeActive && checkAvailabilityMember">
                <div class="message-card">
                    <h4 v-text="$t('aube-coin.payments.title')"></h4>
                    <span v-if="!isLoaded()">{{ $t('loading') }}</span>
                    <span v-else>{{ $t(`aube-coin.payments.statuses[${membershipFeeStatus}]`) }}</span>
                </div>
            </div>
            <div v-else>
                <MessageCard
                    :title="$t('aube-coin.payments.title')"
                    :link="'/membership/aube-coin-policy'"
                    :active="(isMembershipFeeActive || !canCampaignActive) && checkAvailabilityMember"
                    :disable="!isLoaded() || !isKycActive || !isAubeCoinStakingApplied || !checkAvailabilityMember"
                >
                    {{ isLoaded() ? $t(`aube-coin.payments.statuses[${membershipFeeStatus}]`) : $t("loading") }}
                </MessageCard>
            </div>

            <!-- フォルシングSmart Pool優待制度 -->
            <div class="smart-pool-benefit">
                <p class="font-weight-bold mb-0">{{ $t('aube-coin.account_status_v3.smart_pool_benefit.title') }}</p>
                <p class="font-weight-bold mb-0">{{ $t('aube-coin.account_status_v3.smart_pool_benefit.lead') }}</p>
                <p class="mb-0">{{ $t('aube-coin.account_status_v3.smart_pool_benefit.condition1') }}</p>
                <p>{{ $t('aube-coin.account_status_v3.smart_pool_benefit.condition2') }}</p>
                <p class="mt-4">{{ $t('aube-coin.account_status_v3.smart_pool_benefit.guide') }}</p>
                <p class="mt-4">
                    <a :href="smartPoolBenefitFormUrl" target="_blank" rel="noopener noreferrer" class="font-weight-bold">
                        {{ $t('aube-coin.account_status_v3.smart_pool_benefit.form_link') }}
                    </a>
                </p>
            </div>

        </div>
    </div>
</template>

<script>
import userService from '../../services/UserService';
import MessageCard from "./MessageCard.vue";
import config from '../../../config';
import { KYC_SETTINGS_APPROVAL, STATUS_NOT_SET, STATUS_ACTIVE, STATUS_RENEWAL, MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD} from '../../utils/Const';

export default {
  name: "AubeCoinForthingStatus",
  components: { MessageCard },

  data() {
    return {
      kycStatus: undefined,
      email: undefined,
      connectorId: undefined,
      latestAubeCoinMembershipFee: undefined,
      latestMembershipFee: undefined,
      isAubeCoinStakingApplied: undefined,
      isCampaign: false,
      isCampaignCompletedAt: false,
      questId: undefined,
      forceClubId: undefined,
      checkAvailabilityMember: false,
      memberTypeId: undefined,
      smartPoolBenefitFormUrl: config.forthingSmartPoolBenefitFormUrl,
    };
  },
  computed: {
    membershipFeeStatus() {
        if (
            this.isCampaign &&
            this.isCampaignCompletedAt &&
            this.isAubeCoinStakingApplied &&
            (
            (this.latestAubeCoinMembershipFee && this.latestAubeCoinMembershipFee.is_active) ||
            (this.latestMembershipFee && this.latestMembershipFee.is_active)
            )
        ) {
            return STATUS_ACTIVE;
        }

        if (!this.isAubeCoinStakingApplied ||
            (!this.latestAubeCoinMembershipFee && !this.latestMembershipFee)) {
            return STATUS_NOT_SET;
        }

        const isActive =
            (this.latestAubeCoinMembershipFee && this.latestAubeCoinMembershipFee.is_active) ||
            (this.latestMembershipFee && this.latestMembershipFee.is_active);

        return isActive ? STATUS_ACTIVE : STATUS_RENEWAL;
    },

    aubeCoinStackingStatus: function (){
        if (!this.isAubeCoinStakingApplied){
            return STATUS_NOT_SET; //未完了
        } else {
            return STATUS_ACTIVE;  //完了
        }
    },

    isKycActive() {
      return Number(this.kycStatus) == KYC_SETTINGS_APPROVAL;
    },

    isMembershipFeeActive() {
        if (!this.isAubeCoinStakingApplied || !this.isKycActive) {
            return false;
        }

        const hasActiveAubeMembershipFee =
            this.latestAubeCoinMembershipFee &&
            this.latestAubeCoinMembershipFee.is_active;

        // check membershipfee is active for  user Patter B (advance )
        const hasActiveMembershipFee =
            this.latestMembershipFee &&
            this.latestMembershipFee.is_active;

        return hasActiveAubeMembershipFee || hasActiveMembershipFee;
    },

    canCampaignActive() {
        return this.isCampaign && this.isCampaignCompletedAt && this.latestAubeCoinMembershipFee && this.latestAubeCoinMembershipFee.is_active;
    },

    showForceClubId() {
        if (this.memberTypeId === null || this.memberTypeId === undefined) {
            return false;
        }
        const memberTypes = [MEMBER_TYPE_ID_PROGRESS, MEMBER_TYPE_ID_PROGRESS_CHILD];
        return !memberTypes.includes(this.memberTypeId);
    },
  },
  methods: {
    isLoaded() {
        return (
            this.kycStatus       !== undefined &&
            this.latestAubeCoinMembershipFee !== undefined &&
            this.isAubeCoinStakingApplied !== undefined &&
            this.checkAvailabilityMember !== undefined
        );
    },

    async fetchData() {
        const data = (await userService.getUserFrontendData(true)).data;
        const availabilityCheckData = await userService.questAvailabilityCheckData(); //QuestAvailabilityCheck退会、停止情報取得

        this.memberTypeId = data.member_type_id
        this.kycStatus = (data.kyc && data.kyc.status) ? data.kyc.status : '0';
        this.latestAubeCoinMembershipFee = (data.latestAubeCoinMembershipFee) ? data.latestAubeCoinMembershipFee : null;
        this.latestMembershipFee = (data.latestMembershipFee) ? data.latestMembershipFee : null;
        this.email = (data.email) ? data.email : '';
        this.connectorId = (data.connector && data.connector.connector_id) ? data.connector.connector_id : '';
        this.isAubeCoinStakingApplied = (data.is_aube_coin_staking_applied !== undefined) ? data.is_aube_coin_staking_applied : false;
        this.isCampaign = data.is_campaign ? data.is_campaign : false ;
        this.isCampaignCompletedAt = data.isCampaignCompletedAt ? data.isCampaignCompletedAt : null ;
        this.questId = (data.quest && data.quest.quest_id) ? data.quest.quest_id : null ;
        this.forceClubId = (data.force_club_id) ? data.force_club_id : '';

        //Quest 退会、停止状態確認
        this.checkAvailabilityMember = !!availabilityCheckData.data;
    },

  },
  async mounted() {
    await this.fetchData();
  },
};
</script>
<style >
    .message-card {
        color: #fff;
        padding: 10px;
        text-align: center;
        margin: 0 auto 20px;
        background: #451493;
    }
    .message-card-disable {
        background-color: #c6c6c6 !important;;
    }
    .message-card-disable:hover {
        background-color: #c6c6c6 !important;;
    }
    .message-card:hover {
        background: #350f71;
    }
    .message-card.active{
        cursor: pointer;
        background: #EDE3E9;
        color: #2B2D42;
    }
    .message-card.active:hover{
        background: #e3c9d9;
    }
    .show_ID {
        margin: -10px 0px 40px 0px;
        font-size: 1.2em;
    }
    .warning{
        color:red;
    }
    .smart-pool-benefit {
        margin-top: 10px;
        color: #2B2D42;
    }
    .smart-pool-benefit a {
        text-decoration: underline;
        word-break: break-word;
    }
    /* Override global a:hover { text-decoration: none } (also sticky :hover/:focus on mobile after returning to the tab) */
    .smart-pool-benefit a:hover,
    .smart-pool-benefit a:focus,
    .smart-pool-benefit a:active,
    .smart-pool-benefit a:visited {
        text-decoration: underline;
    }
    @media screen and (max-width: 767px) {
        .show_ID span {
            font-weight: bold;
        }
    }
</style>
